import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function ProofSection() {
  return <SectionWrapper bgColor="white" data-id="element-113">
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-forest text-center mb-12" data-id="element-114">
        Lo que cambia en 7 días
      </h2>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-115">
        <div className="bg-brand-cream p-8 rounded-3xl text-center flex flex-col justify-center" data-id="element-116">
          <div className="text-5xl font-bold text-brand-amber mb-4" data-id="element-117">Día 4</div>
          <p className="text-xl text-gray-800" data-id="element-118">
            Al cuarto día de aplicar las sustituciones químicas, la mayoría de
            los lectores reportan que el sabor amargo al despertar desaparece.
          </p>
        </div>

        <div className="bg-brand-forest text-white p-8 rounded-3xl text-center flex flex-col justify-center shadow-lg" data-id="element-119">
          <div className="text-6xl font-bold text-brand-amber mb-4" data-id="element-120">85%</div>
          <p className="text-xl text-brand-cream/90" data-id="element-121">
            Para el séptimo día, el 85% logra reducir o eliminar por completo el
            uso de antiácidos de rescate durante la noche, recuperando un sueño
            profundo y reparador.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}